import { useTheme } from '@mui/material';
import { HashLoader } from 'react-spinners';

export const LoadingIndicator = () => {
  const theme = useTheme();

  return (
    <div>
      <HashLoader color={theme.palette.primary.main} />
    </div>
  );
};
